/**
 * HOW TO ADD NEW WHITELABEL BRAND:
 * FRONTEND:
 * - if needed: update relevant information to default whitelabel brand WAKU (src/config/whitelabel.ts)
 * - create new object with data in "whitelabelBrands" (src/config/whitelabel.ts)
 * - add app header logo (2000x400 | ~5:1 | PNG) to "public/whitelabel/<KEY>/logo.png" (LOCAL FALLBACK)
 * - upload app header logo to dev & prod Supabase-Storage (whitelabel/<KEY>/logo.png)
 * - upload email header logo (1280x340 | ~4:1 | PNG,JPEG) to dev & prod Supabase-Storage (whitelabel/<KEY>/email-logo.png)
 * - create new theme (light & dark) in "themes" (src/styles/themes.ts)
 * FUNCTIONS:
 * - if needed: update relevant information to default whitelabel brand WAKU (supabase/functions/_shared/whitelabel.ts)
 * - relevant whitelabel brand information is pulled from database
 * BACKEND:
 * - if needed: update relevant information to default whitelabel brand WAKU (SENSE-BACKEND/internal/models/whitelabel_brands.go)
 * - add new whitelabel_brand to database "whitelabel_brands"
 * - set whitelabel brand ID to relevant workspaces ("whitelabel_brand_id") via database
 */

export interface WhitelabelBrand {
  key: string;
  name: string;
  urls: string[]; // all known brand URLs (dev & prod)
  theme: WhitelabelBrandTheme;
}

export type WhitelabelBrandTheme = "waku" | "logisticsag" | "safelog" | "hai" | "meili";

export const defaultWhitelabelBrand: WhitelabelBrand = {
  key: "waku",
  name: "WAKU Care",
  urls: ["care-next.waku-sense.dev", "care.waku-sense.dev", "app.waku-robotics.com"],
  theme: "waku",
};

export const whitelabelBrands: WhitelabelBrand[] = [
  defaultWhitelabelBrand,
  {
    key: "logistics-ag",
    name: "LogisticsAG",
    urls: ["logistics-ag.waku-sense.dev", "logistics-ag.waku-robotics.com"],
    theme: "logisticsag",
  },
  {
    key: "safelog",
    name: "Safelog Maintenance Cloud",
    urls: ["safelog.waku-sense.dev", "safelog.waku-robotics.com"],
    theme: "safelog",
  },
  {
    key: "hai",
    name: "Hai Robotics Service Cloud",
    urls: ["hai-robotics.waku-sense.dev", "hai-robotics.waku-robotics.com"],
    theme: "hai",
  },
  {
    key: "meili",
    name: "Meili Maintenance Cloud",
    urls: ["meili.waku-sense.dev", "meili.waku-robotics.com"],
    theme: "meili",
  },
];
